import { Pipe, PipeTransform } from '@angular/core';
import { PriceService } from '@df/ui/price/price.service';

@Pipe({
    name: 'price',
    standalone: true
})
export class PricePipe implements PipeTransform {
    constructor(private priceService: PriceService) {}
    transform(value: number, precision?: number | string, currencySymbol?: string): string | number | undefined {
        return this.priceService.toPlainString(value, precision, currencySymbol);
    }
}
